import { createFileRoute } from "@tanstack/react-router";
import NetworkToolkitPage from "@/pages/NetworkToolkitPage";

export const Route = createFileRoute("/tools/network-toolkit")({
  component: NetworkToolkitPage,
});
